import wixWindow from 'wix-window';

$w.onReady(function () {
	let FormFactor = wixWindow.formFactor // "Mobile" /"Desktop"
	let language = wixWindow.multilingual.currentLanguage; // "en"
	if (FormFactor !== "Mobile")
	{
	if (language === "en")
	{
		$w('#statebox8').changeState("EN1")
		
	}
	else if (language === "he"){
		$w('#statebox8').changeState("HE1")
	}
	}
	else
	{
		$w('#statebox8').collapse();
		 if (language === "he"){
		$w('#BurgerMenu').show()
		$w('#mobileMenu1').hide();	
		 }
	}
});

export function button14_mouseIn(event) {
	$w('#box18').show()
}

export function button14_mouseOut(event) {
	$w('#box18').hide()
}

export function button16_mouseIn(event) {
	$w('#button16').expand()
}

export function button16_mouseOut(event) {
	$w('#button16').collapse()
}

export function button8_mouseIn(event) {$w('#box17').show()	}
export function button8_mouseOut(event) {$w('#box17').hide()}
export function box18_mouseIn(event){$w('#box18').show()}
export function box18_mouseOut(event) {$w('#box18').hide()}

export function button20_mouseIn(event) {$w('#box16').show()}
export function button20_mouseOut(event) {$w('#box16').hide()}

export function box16_mouseIn(event)  {$w('#box16').show()}

export function box16_mouseOut(event) {$w('#box16').hide()}

export function box17_mouseIn(event)  {$w('#box17').show()}

export function box17_mouseOut(event)  {$w('#box17').hide()}

export function header1_mouseOut(event) {
	$w('#box17').hide();
	$w('#box16').hide();
	$w('#box17').hide()
}